import { render } from "./ThreadsFormInput.vue?vue&type=template&id=a2cc9f1e&scoped=true&ts=true"
import script from "./ThreadsFormInput.vue?vue&type=script&lang=ts"
export * from "./ThreadsFormInput.vue?vue&type=script&lang=ts"

import "./ThreadsFormInput.vue?vue&type=style&index=0&id=a2cc9f1e&scoped=true&lang=css"

import exportComponent from "/home/kuradmin/dev-frontend-siputra/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2cc9f1e"]])

export default __exports__